<template>
  <div
    :class="{
      guide_add_home_marker: isGuidingMarker(),
      guide_paddy_field_add: isGuidingPaddyFieldAdd(),
      guide_workitem_edit: isGuidingWorkItemEdit(),
    }"
  >
    <div id="side-menu" :class="{ open: expandMenu }">
      <div v-if="!isMobileAny()" class="logo">
        <img src="@/assets/logo.png" @click="onClickHome" />
      </div>
      <div class="date">
        <div id="datetime">{{ nowDateTime() }}</div>
      </div>
      <div class="weather">
        <div id="area">{{ areaName }}</div>
        <div id="temperature">{{ temperature }}℃</div>
      </div>
      <div class="account" id="user-menu" @click="onClickUser">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" fill="#555" />
          <path d="M0 0h24v24H0z" fill="none" />
        </svg>
        <div id="icon">
          <img src="@/assets/ic_account.svg" />
        </div>
        <div id="id">{{ displayName }}</div>
      </div>
      <div>
        <transition v-if="expandUserMenu" name="dropdown" appear>
          <div class="user-dropdown">
            <div @click="onClickPersonalSettings">
              <span>個人設定</span>
            </div>
            <div @click="signOut">
              <span>サインアウト</span>
            </div>
          </div>
        </transition>
      </div>
      <div class="product">
        <div id="message" :class="{ active: showMessage }">
          {{ sysMessage }}
        </div>
        <div id="button-area" :class="{ active: isFree }">
          <div
            class="btn-submit"
            :class="{
              disabled: !isRootUser,
            }"
          >
            <router-link :to="{ name: 'payment' }" @click.native="onClickMenuPayment">
              <div></div>
              <span>有料プラン申込</span>
            </router-link>
          </div>
        </div>
      </div>
      <div class="management" v-if="currentManagementId">
        <template v-if="isDisabledMenu">
          <div class="disp-area">
            <span>{{ currentManagementName }}年</span>
          </div>
        </template>
        <template v-else>
          <select v-model="currentManagementId" @change="onChangeManagement">
            <option
              v-for="item in managementData"
              :key="item.management_id"
              :value="item.management_id"
            >
              {{ item.year }}年
            </option>
          </select>
        </template>
      </div>
      <div class="menu-items">
        <template v-if="isDisabledMenu">
          <ul>
            <router-link
              :to="{ name: 'dashboard' }"
              @click.native="onClickMenuDashboard"
              tag="li"
              active-class="selected"
              id="menu-item14"
            >
              <div></div>
              <span>ダッシュボード</span>
            </router-link>
            <li id="menu-item2" class="disabled">
              <div></div>
              <span>ほ場マップ</span>
            </li>
            <li id="menu-item1" class="disabled">
              <div></div>
              <span>作業入力</span>
            </li>
            <li id="menu-item-water-gate" class="disabled">
              <div></div>
              <span>水門マップ</span>
            </li>
            <li v-if="isWater" id="menu-item3" class="disabled">
              <div></div>
              <span>水管理</span>
            </li>
            <li id="menu-item5" class="disabled">
              <div></div>
              <span>年次レポート</span>
            </li>
            <li
              v-if="!isMobileAny()"
              id="menu-item-setting"
              :class="{ selected: expandSettings }"
              @click="onClickSettings"
            >
              <div></div>
              <span>設定</span>
            </li>
            <ul
              v-if="!isMobileAny()"
              class="sub-menu"
              :class="{ active: expandSettings }"
            >
              <li id="menu-item-paddy-field" class="disabled">
                <div></div>
                <span>ほ場</span>
              </li>
              <li id="menu-item15" class="disabled">
                <div></div>
                <span>品種</span>
              </li>
              <li id="menu-item9" class="disabled">
                <div></div>
                <span>作業項目</span>
              </li>
              <li id="menu-item13" class="disabled">
                <div></div>
                <span>累積気温</span>
              </li>
              <li id="menu-item8" class="disabled">
                <div></div>
                <span>ユーザー</span>
              </li>
              <router-link
                :to="{ name: 'markers' }"
                @click.native="onClickMenuHome"
                tag="li"
                active-class="selected"
                id="menu-item16"
              >
                <div></div>
                <span>ホーム位置</span>
              </router-link>
              <li id="menu-item22" class="disabled">
                <div></div>
                <span>ランドマーク</span>
              </li>
            </ul>
            <router-link
              :to="{ name: 'inquiry' }"
              @click.native="onClickMenuInquiry"
              tag="li"
              active-class="selected"
              id="menu-item17"
            >
              <div></div>
              <span>お問い合わせ・ご要望</span>
            </router-link>
          </ul>
        </template>
        <template v-else>
          <template v-if="isPastDisabledMenu">
            <ul>
              <router-link
                :to="{ name: 'dashboard' }"
                @click.native="onClickMenuDashboard"
                tag="li"
                active-class="selected"
                id="menu-item14"
              >
                <div></div>
                <span>ダッシュボード</span>
              </router-link>
              <router-link
                :to="{ name: 'work-history-show' }"
                @click.native="onClickMenuPaddyMap"
                tag="li"
                active-class="selected"
                id="menu-item2"
              >
                <div></div>
                <span>ほ場マップ</span>
              </router-link>
              <li id="menu-item1" class="disabled">
                <div></div>
                <span>作業入力</span>
              </li>
              <li id="menu-item-water-gate" class="disabled">
                <div></div>
                <span>水門マップ</span>
              </li>
              <li id="menu-item3" v-if="isWater" class="disabled">
                <div></div>
                <span>水管理</span>
              </li>
              <li
                v-if="!isMobileAny()"
                id="menu-item5"
                :class="{ selected: expandArchives }"
                @click="onClickArchives"
              >
                <div></div>
                <span>年次レポート</span>
              </li>
              <ul
                v-if="!isMobileAny()"
                class="sub-menu"
                :class="{ active: expandArchives }"
              >
                <li
                  id="menu-item18"
                  :class="{ selected: expandArchiveWork }"
                  @click="expandArchiveWork = !expandArchiveWork"
                >
                  <div></div>
                  <span>作業実績</span>
                </li>
                <ul class="sub-menu" :class="{ active: expandArchiveWork }">
                  <router-link
                    :to="{ name: 'archives-work-paddy' }"
                    @click.native="onClickMenuArchiveWorkPaddy"
                    tag="li"
                    active-class="selected"
                    id="menu-item23"
                  >
                    <div></div>
                    <span>ほ場作業</span>
                  </router-link>
                  <router-link
                    :to="{ name: 'archives-work-notpaddy' }"
                    @click.native="onClickMenuArchiveWorkNotPaddy"
                    tag="li"
                    active-class="selected"
                    id="menu-item24"
                  >
                    <div></div>
                    <span>ほ場外作業</span>
                  </router-link>
                </ul>
                <router-link
                  :to="{ name: 'archives-information' }"
                  @click.native="onClickMenuArchiveInformation"
                  tag="li"
                  active-class="selected"
                  id="menu-item19"
                >
                  <div></div>
                  <span>お知らせ</span>
                </router-link>
                <router-link
                  :to="{ name: 'archives-log' }"
                  @click.native="onClickMenuArchiveWorkLog"
                  tag="li"
                  active-class="selected"
                  id="menu-item20"
                >
                  <div></div>
                  <span>作業ログ</span>
                </router-link>
                <router-link
                  :to="{ name: 'archives-water-gate' }"
                  @click.native="onClickMenuArchiveWaterGateLog"
                  tag="li"
                  active-class="selected"
                  id="menu-item26"
                >
                  <div></div>
                  <span>水門ログ</span>
                </router-link>
                <router-link
                  :to="{ name: 'archives-weather' }"
                  @click.native="onClickMenuArchiveWeather"
                  tag="li"
                  active-class="selected"
                  id="menu-item21"
                >
                  <div></div>
                  <span>天気</span>
                </router-link>
                <router-link
                  v-if="isWater"
                  :to="{ name: 'archives-water' }"
                  @click.native="onClickMenuArchiveSensor"
                  tag="li"
                  active-class="selected"
                  id="menu-item3"
                >
                  <div></div>
                  <span>水位</span>
                </router-link>
              </ul>
              <li
                v-if="!isMobileAny()"
                id="menu-item-setting"
                :class="{ selected: expandSettings }"
                @click="onClickSettings"
              >
                <div></div>
                <span>設定</span>
              </li>
              <ul
                v-if="!isMobileAny()"
                class="sub-menu"
                :class="{ active: expandSettings }"
              >
                <li
                  id="menu-item-paddy-field"
                  :class="{ selected: expandPaddyField }"
                  @click="expandPaddyField = !expandPaddyField"
                >
                  <div></div>
                  <span>ほ場</span>
                </li>
                <ul class="sub-menu" :class="{ active: expandPaddyField }">
                  <li id="menu-item7" class="disabled">
                    <div></div>
                    <span>登録</span>
                  </li>
                  <router-link
                    :to="{ name: 'paddy-field-show' }"
                    @click.native="onClickMenuPaddyEdit"
                    tag="li"
                    active-class="selected"
                    id="menu-item11"
                  >
                    <div></div>
                    <span>編集</span>
                  </router-link>
                </ul>
                <router-link
                  :to="{ name: 'brands' }"
                  @click.native="onClickMenuBrand"
                  tag="li"
                  active-class="selected"
                  id="menu-item15"
                >
                  <div></div>
                  <span>品種</span>
                </router-link>
                <router-link
                  :to="{ name: 'works' }"
                  @click.native="onClickMenuWorkItem"
                  tag="li"
                  active-class="selected"
                  id="menu-item9"
                >
                  <div></div>
                  <span>作業項目</span>
                </router-link>
                <router-link
                  :to="{ name: 'weather-settings-show' }"
                  @click.native="onClickMenuWeather"
                  tag="li"
                  active-class="selected"
                  id="menu-item13"
                >
                  <div></div>
                  <span>累積気温</span>
                </router-link>
                <li id="menu-item8" class="disabled">
                  <div></div>
                  <span>ユーザー</span>
                </li>
                <li id="menu-item16" class="disabled">
                  <div></div>
                  <span>ホーム位置</span>
                </li>
                <li id="menu-item22" class="disabled">
                  <div></div>
                  <span>ランドマーク</span>
                </li>
              </ul>
              <router-link
                :to="{ name: 'inquiry' }"
                @click.native="onClickMenuInquiry"
                tag="li"
                active-class="selected"
                id="menu-item17"
              >
                <div></div>
                <span>お問い合わせ・ご要望</span>
              </router-link>
            </ul>
          </template>
          <template v-else>
            <ul>
              <router-link
                :to="{ name: 'dashboard' }"
                @click.native="onClickMenuDashboard"
                tag="li"
                active-class="selected"
                id="menu-item14"
              >
                <div></div>
                <span>ダッシュボード</span>
              </router-link>
              <router-link
                :to="{ name: 'work-history-show' }"
                @click.native="onClickMenuPaddyMap"
                tag="li"
                active-class="selected"
                id="menu-item2"
              >
                <div></div>
                <span>ほ場マップ</span>
              </router-link>
              <router-link
                :to="{ name: 'work-history-add' }"
                @click.native="onClickMenuWorkInput"
                tag="li"
                active-class="selected"
                id="menu-item1"
              >
                <div></div>
                <span>作業入力</span>
              </router-link>
              <router-link
                :to="{ name: 'water-gate-put-show' }"
                @click.native="onClickMenuWaterGate"
                tag="li"
                active-class="selected"
                id="menu-item-water-gate"
              >
                <div></div>
                <span>水門マップ</span>
              </router-link>
              <li
                v-if="isWater"
                id="menu-item3"
                :class="{ selected: expandWater }"
                @click="expandWater = !expandWater"
              >
                <div></div>
                <span>水管理</span>
              </li>
              <ul
                class="sub-menu"
                :class="{ active: expandWater }"
              >
                <router-link
                  :to="{ name: 'water-show' }"
                  @click.native="onClickMenuSensor"
                  tag="li"
                  active-class="selected"
                  id="menu-item3"
                >
                  <div></div>
                  <span>水位マップ</span>
                </router-link>
                <router-link
                  v-if="isWater"
                  :to="{ name: 'sensor-add' }"
                  @click.native="onClickMenuSensorSetting"
                  tag="li"
                  active-class="selected"
                  id="menu-item3"
                >
                  <div></div>
                  <span>センサー設置</span>
                </router-link>
                <router-link
                  v-if="isWater"
                  :to="{ name: 'sensor-settings' }"
                  @click.native="onClickMenuSensorAlert"
                  tag="li"
                  active-class="selected"
                  id="menu-item10"
                >
                  <div></div>
                  <span>通知設定</span>
                </router-link>
              </ul>
              <li
                v-if="!isMobileAny()"
                id="menu-item5"
                :class="{ selected: expandArchives }"
                @click="onClickArchives"
              >
                <div></div>
                <span>年次レポート</span>
              </li>
              <ul
                v-if="!isMobileAny()"
                class="sub-menu"
                :class="{ active: expandArchives }"
              >
                <li
                  id="menu-item18"
                  :class="{ selected: expandArchiveWork }"
                  @click="expandArchiveWork = !expandArchiveWork"
                >
                  <div></div>
                  <span>作業実績</span>
                </li>
                <ul class="sub-menu" :class="{ active: expandArchiveWork }">
                  <router-link
                    :to="{ name: 'archives-work-paddy' }"
                    @click.native="onClickMenuArchiveWorkPaddy"
                    tag="li"
                    active-class="selected"
                    id="menu-item23"
                  >
                    <div></div>
                    <span>ほ場作業</span>
                  </router-link>
                  <router-link
                    :to="{ name: 'archives-work-notpaddy' }"
                    @click.native="onClickMenuArchiveWorkNotPaddy"
                    tag="li"
                    active-class="selected"
                    id="menu-item24"
                  >
                    <div></div>
                    <span>ほ場外作業</span>
                  </router-link>
                </ul>
                <router-link
                  :to="{ name: 'archives-information' }"
                  @click.native="onClickMenuArchiveInformation"
                  tag="li"
                  active-class="selected"
                  id="menu-item19"
                >
                  <div></div>
                  <span>お知らせ</span>
                </router-link>
                <router-link
                  :to="{ name: 'archives-log' }"
                  @click.native="onClickMenuArchiveWorkLog"
                  tag="li"
                  active-class="selected"
                  id="menu-item20"
                >
                  <div></div>
                  <span>作業ログ</span>
                </router-link>
                <router-link
                  :to="{ name: 'archives-water-gate' }"
                  @click.native="onClickMenuArchiveWaterGateLog"
                  tag="li"
                  active-class="selected"
                  id="menu-item26"
                >
                  <div></div>
                  <span>水門ログ</span>
                </router-link>
                <router-link
                  :to="{ name: 'archives-weather' }"
                  @click.native="onClickMenuArchiveWeather"
                  tag="li"
                  active-class="selected"
                  id="menu-item21"
                >
                  <div></div>
                  <span>天気</span>
                </router-link>
                <router-link
                  v-if="isWater"
                  :to="{ name: 'archives-water' }"
                  @click.native="onClickMenuArchiveSensor"
                  tag="li"
                  active-class="selected"
                  id="menu-item3"
                >
                  <div></div>
                  <span>水位</span>
                </router-link>
              </ul>
              <li
                v-if="!isMobileAny()"
                id="menu-item-setting"
                :class="{ selected: expandSettings }"
                @click="onClickSettings"
              >
                <div></div>
                <span>設定</span>
              </li>
              <ul
                v-if="!isMobileAny()"
                class="sub-menu"
                :class="{ active: expandSettings }"
              >
                <li
                  id="menu-item-paddy-field"
                  :class="{ selected: expandPaddyField }"
                  @click="expandPaddyField = !expandPaddyField"
                >
                  <div></div>
                  <span>ほ場</span>
                </li>
                <ul class="sub-menu" :class="{ active: expandPaddyField }">
                  <router-link
                    :to="{ name: 'paddy-field-add' }"
                    @click.native="onClickMenuPaddyAdd"
                    tag="li"
                    active-class="selected"
                    id="menu-item7"
                  >
                    <div></div>
                    <span>登録</span>
                  </router-link>
                  <router-link
                    :to="{ name: 'paddy-field-show' }"
                    @click.native="onClickMenuPaddyEdit"
                    tag="li"
                    active-class="selected"
                    id="menu-item11"
                  >
                    <div></div>
                    <span>編集</span>
                  </router-link>
                </ul>
                <router-link
                  :to="{ name: 'brands' }"
                  @click.native="onClickMenuBrand"
                  tag="li"
                  active-class="selected"
                  id="menu-item15"
                >
                  <div></div>
                  <span>品種</span>
                </router-link>
                <router-link
                  :to="{ name: 'works' }"
                  @click.native="onClickMenuWorkItem"
                  tag="li"
                  active-class="selected"
                  id="menu-item9"
                >
                  <div></div>
                  <span>作業項目</span>
                </router-link>
                <router-link
                  :to="{ name: 'weather-settings-show' }"
                  @click.native="onClickMenuWeather"
                  tag="li"
                  active-class="selected"
                  id="menu-item13"
                >
                  <div></div>
                  <span>累積気温</span>
                </router-link>
                <router-link
                  :to="{ name: 'users' }"
                  @click.native="onClickMenuUser"
                  tag="li"
                  active-class="selected"
                  id="menu-item8"
                >
                  <div></div>
                  <span>ユーザー</span>
                </router-link>
                <router-link
                  :to="{ name: 'markers' }"
                  @click.native="onClickMenuHome"
                  tag="li"
                  active-class="selected"
                  id="menu-item16"
                >
                  <div></div>
                  <span>ホーム位置</span>
                </router-link>
                <router-link
                  :to="{ name: 'landmarks' }"
                  @click.native="onClickMenuLandmark"
                  tag="li"
                  active-class="selected"
                  id="menu-item22"
                >
                  <div></div>
                  <span>ランドマーク</span>
                </router-link>
              </ul>
              <router-link
                :to="{ name: 'inquiry' }"
                @click.native="onClickMenuInquiry"
                tag="li"
                active-class="selected"
                id="menu-item17"
              >
                <div></div>
                <span>お問い合わせ・ご要望</span>
              </router-link>
            </ul>
          </template>
        </template>
      </div>
    </div>
    <div
      id="menu-background"
      :class="{ open: expandMenu }"
      @click="onClickMenuBackground"
    ></div>
  </div>
</template>

<script>
import Loader from "@/mixins/loader";
//import { AmplifyEventBus } from "aws-amplify-vue";
import { mapActions, mapGetters } from "vuex";
import isMobile from "@/mixins/ismobile";
import { GUIDE_PHASE, MENU_CODE, OPERATION_TYPE } from "@/constants/constants";
import Contract from "@/mixins/contract";

const RELOAD_PAGES = [
  "dashboard",
  "paddy-field-show",
  "work-history-show",
  "weather-settings-show",
  "archives",
  "works",
  "brands",
  "archives-work-paddy",
  "archives-work-notpaddy",
  "archives-weather",
  "archives-information",
  "archives-log",
  "archives-water-gate",
];
const CUSTOM_PAGES = [
  {
    to: "works",
    from: [
      "works-item-edit",
      "works-detail-edit",
      "works-item-order",
      "works-order",
    ],
  },
  {
    to: "brands",
    from: ["brands-detail"],
  },
  {
    to: "weather-settings-show",
    from: ["weather-settings-add", "weather-settings-edit"],
  },
];

export default {
  mixins: [Loader, isMobile, Contract],

  props: {
    expand: {
      type: Boolean,
      default: false,
    },
    guidePhase: {
      type: Number,
      default: null,
    },
  },

  data() {
    return {
      expandMenu: false,
      expandUserMenu: false,
      expandSettings: false,
      expandWater: false,
      expandPaddyField: false,
      expandArchives: false,
      expandArchiveWork: false,
      expandWaterGate: false,
      temperature: null,
      displayName: null,
      areaName: null,
      isWater: false,
      isReadOnly: false,
      isPast: false,
      isFree: false,
      showMessage: false,
      sysMessage: null,
      isRootUser: false,
      managementData: [],
      currentManagementId: null,
      currentManagementName: null,
    };
  },
  async mounted() {
    // 地域情報Watch
    this.$store.watch(
      (state, getters) => getters.getAreaName,
      (newValue) => {
        this.areaName = newValue;
      }
    );
    // 気温Watch
    this.$store.watch(
      (state, getters) => getters.getNowTemperature,
      (newValue) => {
        this.temperature = newValue;
      }
    );
    // Account Watch
    this.$store.watch(
      (state, getters) => getters.getAccount,
      (newValue) => {
        this.judgeAccountData(newValue);
      },
      { deep: true }
    );
    try {
      await this.loadData();
    } catch (error) {
      console.log(error);
    }
  },
  computed: {
    isDisabledMenu() {
      return this.isReadOnly;
    },
    isPastDisabledMenu() {
      return this.isPast;
    },
    getDisplayName() {
      return this.$store.getters.getDisplayName;
    },
  },

  watch: {
    expand(value) {
      this.expandMenu = value;
    },
    guidePhase(value) {
      // 設定メニューが開くのを描画してから
      // 対象メニューが画面に表示されるようスクロールする
      if (value === GUIDE_PHASE.GUIDE_ADD_HOME_MARKER) {
        this.expandSettings = true;
        this.expandPaddyField = false;
        this.expandWater = false;
        this.$nextTick(function() {
          // メニュー展開のアニメーションがスクロールに間に合っていないのでtransitionで指定している0.3s以上待つ
          setTimeout(() => {
            document
              .getElementById("menu-item16")
              .scrollIntoView({ behavior: "smooth", block: "center" });
          }, 500);
        });
      } else if (value === GUIDE_PHASE.GUIDE_PADDY_FIELD_ADD) {
        this.expandSettings = true;
        this.expandPaddyField = true;
        this.expandWater = false;
        this.$nextTick(function() {
          document
            .getElementById("menu-item7")
            .scrollIntoView({ behavior: "smooth", block: "center" });
        });
      } else if (value === GUIDE_PHASE.GUIDE_WORKITEM_EDIT) {
        this.expandSettings = true;
        this.expandPaddyField = false;
        this.expandWater = false;
        this.$nextTick(function() {
          document
            .getElementById("menu-item9")
            .scrollIntoView({ behavior: "smooth", block: "center" });
        });
      }
    },
    getDisplayName(value) {
      this.displayName = value;
    },
  },

  methods: {
    ...mapActions([
      "retrieveWeatherLatest",
      "showProfile",
      "showAccount",
      "showAccountID",
      "showCurrentUserInfo",
      "showUserId",
      "showManagementID",
      "changeCurrentManagementId",
      "accessLogs",
    ]),
    ...mapGetters([
      "getAccountID",
      "getManagements",
      "isPastManagement",
      "getCurrentYear",
      "getAccount",
    ]),

    async loadData() {
      try {
        const acinfo = await this.showAccount(await this.showAccountID());
        const uid = await this.showUserId();
        if (acinfo.root_users && acinfo.root_users.length > 0) {
          this.isRootUser = acinfo.root_users[0] === uid;
        } else {
          this.isRootUser = false;
        }
        this.judgeAccountData(acinfo);
      } catch (error) {
        console.log(error);
      }
      try {
        this.managementData = [];
        const mid = await this.showManagementID();
        const managements = this.getManagements();
        for (let management of managements) {
          let year = parseInt(management.start_datetime.substr(0, 4));
          this.managementData.push({
            year: year,
            management_id: management.management_id,
          });
        }
        this.currentManagementId = mid;
        this.currentManagementName = this.getCurrentYear();
        this.isPast = this.isPastManagement();
      } catch (error) {
        console.log(error);
      }

      try {
        const weatherInfos = await this.retrieveWeatherLatest();
        if (weatherInfos) {
          this.temperature = weatherInfos.temperature;
        }
      } catch (error) {
        console.log(error);
      }

      try {
        await this.showProfile();
      } catch (error) {
        console.log(error);
      }
    },

    onClickUser() {
      this.expandUserMenu = !this.expandUserMenu;
      window.addEventListener("click", this.handleUserMenu);
    },

    handleUserMenu(event) {
      if (!this.$el.querySelector("#user-menu").contains(event.target)) {
        this.expandUserMenu = false;
        window.removeEventListener("click", this.handleUserMenu);
      }
    },

    async signOut() {
      try {
        await this.$Amplify.Auth.signOut();
        // リロードすることでStoreをリフレッシュし、ログイン画面に遷移する
        // if (this.$route.path !== "/") {
        //   this.$router.push("/");
        // }
        // AmplifyEventBus.$emit("authState", "signedOut");
        this.$router.go({ path: "/", force: true });
      } catch (e) {
        const error = this.$Amplify.I18n.get(e.message || e);
        console.log(error);
        // TODO
        alert(error);
      }
    },

    async onAccessLogClick(menu) {
      const chk = await this.checkExpired();
      if (!chk) {
        // 無料期間内のユーザーがアクセスした際に期間外であれば画面をリロードする
        await this.judgeFreePeriod();

        await this.accessLogs({
          menu: menu,
          ope: OPERATION_TYPE.Menu,
        });
      }
    },

    async onClickMenuDashboard() {
      await this.onAccessLogClick(MENU_CODE.DASHBOARD);
    },

    async onClickMenuPaddyMap() {
      await this.onAccessLogClick(MENU_CODE.PADDY_FIELD_MAP);
    },

    async onClickMenuWorkInput() {
      await this.onAccessLogClick(MENU_CODE.WORK_INPUT);
    },

    async onClickMenuArchiveWorkPaddy() {
      await this.onAccessLogClick(MENU_CODE.ARCHIVE_WORK_PADDY);
    },

    async onClickMenuArchiveWorkNotPaddy() {
      await this.onAccessLogClick(MENU_CODE.ARCHIVE_WORK_NOTPADDY);
    },

    async onClickMenuArchiveInformation() {
      await this.onAccessLogClick(MENU_CODE.ARCHIVE_INFORMATION);
    },

    async onClickMenuArchiveWorkLog() {
      await this.onAccessLogClick(MENU_CODE.ARCHIVE_WORK_LOG);
    },

    async onClickMenuArchiveWeather() {
      await this.onAccessLogClick(MENU_CODE.ARCHIVE_WEATHER);
    },

    async onClickMenuArchiveWaterGateLog() {
      await this.onAccessLogClick(MENU_CODE.ARCHIVE_WATER_GATE_LOG);
    },

    async onClickMenuPaddyAdd() {
      await this.onAccessLogClick(MENU_CODE.SETTING_PADDY_FIELD_ADD);
    },

    async onClickMenuPaddyEdit() {
      await this.onAccessLogClick(MENU_CODE.SETTING_PADDY_FIELD_EDIT);
    },

    async onClickMenuBrand() {
      await this.onAccessLogClick(MENU_CODE.SETTING_BRAND);
    },

    async onClickMenuWorkItem() {
      await this.onAccessLogClick(MENU_CODE.SETTING_WORK_ITEM);
    },

    async onClickMenuWeather() {
      await this.onAccessLogClick(MENU_CODE.SETTING_WEATHER);
    },

    async onClickMenuUser() {
      await this.onAccessLogClick(MENU_CODE.SETTING_USER);
    },

    async onClickMenuHome() {
      await this.onAccessLogClick(MENU_CODE.SETTING_HOME);
    },

    async onClickMenuLandmark() {
      await this.onAccessLogClick(MENU_CODE.SETTING_LANDMARK);
    },

    async onClickMenuInquiry() {
      await this.onAccessLogClick(MENU_CODE.INQUIRY);
    },

    async onClickMenuPayment() {
      await this.onAccessLogClick(MENU_CODE.PAYMENT);
    },

    async onClickMenuWaterGate() {
      await this.onAccessLogClick(MENU_CODE.WATER_GATE);
    },

    async onClickMenuSensor() {
      await this.onAccessLogClick(MENU_CODE.SENSOR);
    },

    async onClickMenuSensorSetting() {
      await this.onAccessLogClick(MENU_CODE.SENSOR_SETTING);
    },

    async onClickMenuSensorAlert() {
      await this.onAccessLogClick(MENU_CODE.SENSOR_ALERT);
    },

    async onClickMenuArchiveSensor() {
      await this.onAccessLogClick(MENU_CODE.ARCHIVE_SENSOR);
    },

    async checkExpired() {
      const currentUserInfo = await this.showCurrentUserInfo();
      if (currentUserInfo === null || currentUserInfo.username === undefined) {
        this.signOut();
        return true;
      }      
      return false;
    },

    onClickArchives() {
      this.expandArchives = !this.expandArchives;
      if (!this.expandArchives) {
        this.expandArchiveWork = false;
      }
    },

    onClickSettings() {
      this.expandSettings = !this.expandSettings;
      if (!this.expandSettings) {
        this.expandPaddyField = false;
      }
    },

    onClickWater() {
      this.expandWater = !this.expandWater;
    },

    onClickMenuBackground() {
      this.$emit("clickMenuBackground");
    },

    async onClickPersonalSettings() {
      const chk = await this.checkExpired();
      if (!chk) {
        await this.accessLogs({
          menu: MENU_CODE.SETTING_PERSONAL,
          ope: OPERATION_TYPE.Menu,
        });
        this.expandUserMenu = false;
        this.$router.push({ name: "personal-settings" });
      }
    },

    isGuidingMarker() {
      return this.guidePhase === GUIDE_PHASE.GUIDE_ADD_HOME_MARKER;
    },

    isGuidingPaddyFieldAdd() {
      return this.guidePhase === GUIDE_PHASE.GUIDE_PADDY_FIELD_ADD;
    },

    isGuidingWorkItemEdit() {
      return this.guidePhase === GUIDE_PHASE.GUIDE_WORKITEM_EDIT;
    },

    async onClickHome() {
      const chk = await this.checkExpired();
      if (!chk) {
        this.$router.push({ name: "dashboard" });
      }
    },

    async judgeFreePeriod() {
      // 無料期間か
      if (this.isFree) {
        // 既に期間外であればチェックしない
        if (!this.isReadOnly) {
          const acinfo = this.getAccount();
          if (acinfo) {
            let endTime = acinfo.paying_state.end_datetime;
            const endDateTime = new Date(endTime);
            const nowDateTime = new Date();
            // 日付のみにする
            // const endDate = new Date(endDateTime.getFullYear(), endDateTime.getMonth(), endDateTime.getDate());
            // const nowDate = new Date(nowDateTime.getFullYear(), nowDateTime.getMonth(), nowDateTime.getDate());
            // if (nowDate > endDate) {
            //   // 期間外(アカウント情報参照)
            //   const nowAcInfo = await this.showAccount();
            //   if (this.isAccountExpired(nowAcInfo)) {
            //     // ダッシュボード画面を強制リロード
            //     this.$router.push({ name: "dashboard" });
            //     this.$router.go(0);
            //   };
            // }
            // サーバー側の処理の判定に合わせておく
            if (nowDateTime > endDateTime) {
              // 期間外(アカウント情報参照)
              const nowAcInfo = await this.showAccount();
              if (this.isAccountExpired(nowAcInfo)) {
                // ダッシュボード画面を強制リロード
                this.$router.push({ name: "dashboard" });
                this.$router.go(0);
              };
            }
          }
        }
      }
    },

    judgeAccountData(acinfo) {
      if (acinfo == null) {
        return;
      }
      this.isWater = this.isValidWater(acinfo);
      this.isReadOnly = this.isAccountExpired(acinfo);
      this.isFree = this.isAccountFree(acinfo);
      if (acinfo.display_mode) {
        this.sysMessage = acinfo.display_mode.message;
        if (this.isFree) {
          if (!this.isRootUser) {
            this.sysMessage =
              this.sysMessage + "アカウントを作成したユーザーで申込できます。";
          }
        }
        if (this.sysMessage) {
          this.showMessage = true;
        } else {
          this.showMessage = false;
        }
      }
    },

    nowDateTime() {
      const now = new Date();
      const year = now.getFullYear();
      const month = now.getMonth() + 1;
      const day = now.getDate();
      const week = ["日", "月", "火", "水", "木", "金", "土"][now.getDay()];
      return year + "年" + month + "月" + day + "日" + "(" + week + ")";
    },

    onChangeManagement() {
      this.loading(async () => {
        await this.onAccessLogClick(MENU_CODE.HISTORY);
        this.changeCurrentManagementId(this.currentManagementId);
        this.isPast = this.isPastManagement();
        if (RELOAD_PAGES.includes(this.$route.name)) {
          // リロードする
          this.$emit("reloadMenu");
        } else {
          for (let item of CUSTOM_PAGES) {
            if (item.from.includes(this.$route.name)) {
              // 遷移する
              this.$router.push({ name: item.to });
              return;
            }
          }
          // ダッシュボードに遷移する
          this.$router.push({ name: "dashboard" });
        }
      });
    },
  },
};
</script>
<style lang="scss">
/* TODO scssスタイルに整形 */
#side-menu {
  background: rgb(240, 243, 245);
  margin: 0;
  padding: 0;
  width: 250px;
  height: 100vh;
  box-sizing: border-box;
  /* background: url(../img/menu_bg.png) no-repeat center bottom #fff; */
  background-size: 250px;
  overflow-y: scroll;

  .mobile & {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 30;
    transform: translate(-260px);
    transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
    box-shadow: 0px 0 8px 4px rgba(0, 0, 0, 0.5);

    &.open {
      transform: translate(0);
    }
  }

  select {
    // width: 100%;
    height: 1.9rem;
    border-radius: 20px;
    border: solid 1px var(--purple);
    // padding: 0 38px 0 16px;
    padding: 0 48px 0 26px;
    font-size: 0.9rem;
    outline: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background: url("~@/assets/icons/ic_dropdown.svg") no-repeat
      calc(100% - 10px) center;
    background-size: 25px 25px;
  }

  select:focus {
    background: url("~@/assets/icons/ic_dropdown.svg") no-repeat
      calc(100% - 10px) center var(--purple-tertiary);
    background-size: 25px 25px;
  }
}

#menu-background {
  position: fixed;
  top: 0;
  left: 0;
  content: "";
  display: block;
  width: 0;
  height: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 11;
  opacity: 0;
  transition: opacity 0.3s;

  &.open {
    width: 100%;
    height: 100%;
    opacity: 1;
  }
}

/* ロゴのスタイル */
#side-menu .logo {
  width: 100%;
  /* padding: 20px 0; */
  padding: 20px 40px;
  text-align: center;
  box-sizing: border-box;
}
#side-menu .logo img {
  /* width: 150px; */
  width: 100%;
  cursor: pointer;
}
#side-menu .date {
  width: 80%;
  // height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto 0;
  box-sizing: border-box;
}
#side-menu .date > #datetime {
  width: 100%;
  // height: 1.9rem;
  font-size: 0.9rem;
  text-align: center;
  color: #555;
  // padding: 0.3rem 0.3rem;
  box-sizing: border-box;
  border-radius: 2rem;
  // background: var(--purple);
  .mobile & {
    height: 1.7rem;
    font-size: 0.8rem;
  }
}
/* 年度のスタイル */
#side-menu .management {
  width: 100%;
  padding-top: 20px;
  text-align: center;
  box-sizing: border-box;
}
#side-menu .management .disp-area {
  height: 1.9rem;
  border-radius: 20px;
  border: solid 1px var(--purple);
  font-size: 0.9rem;
  width: 130px;
  margin: 0 auto;

  span {
    vertical-align: middle;
    color: #555;
  }
}

/* お天気情報のスタイル */
#side-menu .weather {
  width: 80%;
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto 0;
  box-sizing: border-box;
}
#side-menu .weather > #area,
#side-menu .weather > #temperature {
  width: 48%;
  height: 1.9rem;
  font-size: 0.9rem;
  text-align: center;
  color: #fff;
  padding: 0.3rem 0.3rem;
  box-sizing: border-box;
  border-radius: 2rem;
  background: var(--purple);
  .mobile & {
    height: 1.7rem;
    font-size: 0.8rem;
  }
}

/* アカウントのスタイル */
#side-menu .account {
  width: 80%;
  height: 40px;
  margin: 0 auto 0;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.9rem;
  color: #555;
  box-sizing: border-box;
  cursor: pointer;
  svg {
    margin: 0 0.5rem 0 -2rem;
  }
  + div {
    position: relative;
  }
}
#side-menu .account > #id {
  text-indent: 0.4rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
#side-menu .product > #message {
  display: none;
  font-size: 14px;
  color: var(--col4);
  padding: 10px;
  &.active {
    display: block;
  }
}
#side-menu .product > #button-area {
  display: none;
  &.active {
    display: block;
  }
}
#side-menu .product > #button-area .btn-submit {
  display: block;
  background: var(--col2);
  font-size: 14px;
  text-align: center;
  width: 150px;
  height: 30px;
  border-radius: 15px;
  color: #fff;
  padding: 6px 20px;
  margin: 10px auto 0px;
  cursor: pointer;

  a {
    text-decoration: none;
    color: #fff;
  }

  &.disabled {
    opacity: 0.5;
    pointer-events: none;
    cursor: pointer;
  }
}

/* メニューのスタイル */
#side-menu .menu-items {
  width: 100%;
  margin: 20px 0 0 0;
  box-sizing: border-box;
}
#side-menu .menu-items ul {
  width: 100%;
  margin: 0;
  padding: 0;
  list-style-type: none;
  box-sizing: border-box;
  user-select: none;
}
#side-menu .menu-items li {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: 60px; /* 各メニューの高さ */
  cursor: pointer;
  background: none;
  z-index: 10;
  display: flex;
  align-items: center;
  border-bottom: 1px solid;
  border-image: linear-gradient(
    to right,
    #fff 0%,
    #fff 10%,
    #eee 10%,
    #eee 100%
  );
  border-image-slice: 1;
  color: var(--purple-secondary);
  .mobile & {
    height: 44px; /* 各メニューの高さ */
  }

  &.disabled {
    pointer-events: none;
    background: lightgray;
  }
}
#side-menu .menu-items li span {
  font-size: 1.1rem;
  padding: 0px 0px 0px 10px;
  transition: padding 0.8s cubic-bezier(0.19, 1, 0.22, 1) 0s;
  .mobile & {
    font-size: 0.9rem;
  }
}
#side-menu .menu-items li#menu-item17 span {
  font-size: 1rem;
}

/* マウスオーバー時の挙動 */
#side-menu .menu-items li::after {
  content: "";
  position: absolute;
  background-color: var(--purple-tertiary);
  width: 100%;
  height: 100%;
  top: 0px;
  left: -250px;
  z-index: -1;
  transition: left 0.8s cubic-bezier(0.19, 1, 0.22, 1) 0s;
  &.disabled {
    background-color: none;
    transition: none;
  }
}
#side-menu .menu-items li:hover::after {
  content: "";
  left: 0px;
  transition: left 0.8s cubic-bezier(0.19, 1, 0.22, 1) 0s;
}
#side-menu .menu-items li:hover > span {
  color: var(--purple);
  padding: 0px 0px 0px 20px;
  transition: padding 0.8s cubic-bezier(0.19, 1, 0.22, 1) 0s;
}
#side-menu .menu-items li > div {
  width: 70px;
  height: 100%;
  border-left: solid 10px var(--purple-secondary);
}

/* 選択時のスタイル */
#side-menu .menu-items li.selected {
  background-color: var(--purple-tertiary);
  color: var(--purple);
}
#side-menu .menu-items li.selected > span {
  color: var(--purple);
}
#side-menu .menu-items li.selected > div {
  border-left: solid 10px var(--purple);
}
#side-menu .menu-items li.selected:hover > span {
  padding: 0px 0px 0px 10px;
}

/* アイコンの指定 */
#menu-item1 > div {
  background: url("~@/assets/icons/ic_rate-review.svg") no-repeat center center;
}
#menu-item2 > div {
  background: url("~@/assets/icons/ic_visibility.svg") no-repeat center center;
}
#menu-item3 > div {
  background: url("~@/assets/icons/ic_thermometer_menu.svg") no-repeat center center;
  background-size: 26px 26px;
}
#menu-item4 > div {
  background: url("~@/assets/icons/ic_wb-sunny.svg") no-repeat center center;
}
#menu-item5 > div {
  background: url("~@/assets/icons/ic_folder.svg") no-repeat center center;
}
#menu-item6 > div {
  background: url("~@/assets/icons/ic_router.svg") no-repeat center center;
}
#menu-item7 > div {
  background: url("~@/assets/icons/ic_view-comfy.svg") no-repeat center center;
}
#menu-item8 > div {
  background: url("~@/assets/icons/ic_account-box.svg") no-repeat center center;
}
#menu-item9 > div {
  background: url("~@/assets/icons/ic_style.svg") no-repeat center center;
}
#menu-item10 > div {
  background: url("~@/assets/icons/ic_notifications_menu.svg") no-repeat center
    center;
}
#menu-item11 > div {
  background: url("~@/assets/icons/ic_view-comfy.svg") no-repeat center center;
}
#menu-item12 > div {
  background: url("~@/assets/icons/ic_water.svg") no-repeat center center;
}
#menu-item13 > div {
  background: url("~@/assets/icons/ic_wb-sunny.svg") no-repeat center center;
}
#menu-item14 > div {
  background: url("~@/assets/icons/ic_dashboard.svg") no-repeat center center;
}
#menu-item15 > div {
  background: url("~@/assets/icons/ic_style.svg") no-repeat center center;
}
#menu-item16 > div {
  background: url("~@/assets/icons/ic_flag_green.svg") no-repeat center center;
}
#menu-item17 > div {
  background: url("~@/assets/icons/ic_email.svg") no-repeat center center;
}
#menu-item18 > div {
  background: url("~@/assets/icons/ic_rate-review.svg") no-repeat center center;
}
#menu-item19 > div {
  background: url("~@/assets/icons/ic_info_menu.svg") no-repeat center center;
}
#menu-item20 > div {
  background: url("~@/assets/icons/ic_done_menu.svg") no-repeat center center;
}
#menu-item21 > div {
  background: url("~@/assets/icons/ic_wb-sunny.svg") no-repeat center center;
}
#menu-item22 > div {
  background: url("~@/assets/icons/ic_pin_drop.svg") no-repeat center center;
}
#menu-item23 > div {
  background: url("~@/assets/icons/ic_rate-review.svg") no-repeat center center;
}
#menu-item24 > div {
  background: url("~@/assets/icons/ic_rate-review.svg") no-repeat center center;
}
#menu-item25 > div {
  background: url("~@/assets/icons/ic_water.svg") no-repeat center center;
}
#menu-item26 > div {
  background: url("~@/assets/icons/ic_water.svg") no-repeat center center;
}
#menu-item-setting > div {
  background: url("~@/assets/icons/ic_setting.svg") no-repeat center center;
  background-size: 26px 26px;
}
#menu-item-paddy-field > div {
  background: url("~@/assets/icons/ic_view-comfy.svg") no-repeat center center;
}
#menu-item-water-gate > div {
  background: url("~@/assets/icons/ic_water.svg") no-repeat center center;
}

#side-menu .menu-items .sub-menu {
  //   opacity: 0;
  visibility: hidden;
  //   height: 0;
  //   transition: ease-in-out 0.3s;
  //   transform: translate(0px, -100px);
  &.active {
    // opacity: 1;
    visibility: visible;
    // transform: translate(0px, 0);
    > li {
      height: 60px;
      border-bottom: 1px solid;
    }
  }

  li {
    padding-left: 1rem;
    height: 0px;
    transition: height 0.3s;
    border-bottom: 0px;
    & > div {
      width: 70px;
      height: 100%;
      border-left: solid 0px var(--purple-secondary);
    }

    &.selected {
      background-color: var(--purple-tertiary);
      color: var(--purple);
      & > span {
        color: var(--purple);
      }
      & > div {
        border-left: solid 0px var(--purple);
      }
      &:hover > span {
        padding: 0px 0px 0px 10px;
      }
    }
  }

  .sub-menu li {
    padding-left: 2rem;
  }
}

.user-dropdown {
  position: absolute;
  box-shadow: 0px 0px 10px 2px grey;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 210px;
  margin: 0 20px;
  border-radius: 5px;
  z-index: 20;
  background-color: white;
  cursor: pointer;

  > div {
    height: 45px;
    display: flex;
    align-items: center;
  }
}
.dropdown-enter,
.dropdown-leave-to {
  opacity: 0;
}
.dropdown-enter-active,
.dropdown-leave-active {
  transition: opacity 0.25s;
}
// 初回ナビゲーション
.desktop.guiding {
  .guide_add_home_marker #menu-item16,
  .guide_paddy_field_add #menu-item7,
  .guide_workitem_edit #menu-item9 {
    z-index: 200;
    background: rgb(240, 243, 245);

    &::before {
      content: "";
      background-image: url("~@/assets/icons/ic_arrow_right.svg");
      background-size: cover;
      width: 3rem;
      height: 3rem;
      position: absolute;
      top: -3rem;
      right: 1rem;
      transform: rotate(90deg);
      background-color: rgb(240, 243, 245);
      border-radius: 50%;
      border: solid 3px var(--purple);
      box-shadow: 0 0 6px 3px;
      animation: bounce 2s infinite;
    }
  }
}
@keyframes bounce {
  0%,
  20%,
  50%,
  80%,
  100% {
    transform: translateY(0) rotate(90deg);
  }

  40% {
    transform: translateY(-20px) rotate(90deg);
  }

  60% {
    transform: translateY(-10px) rotate(90deg);
  }
}
</style>
